export const getProductBenefitTag = ({ display_benefit_tag, promo }: any) => {
  if (
    ['FREEMONTHS', 'FREEMONTHSINCONTRACT', 'NOTPAYUNTIL', 'AMTOFF'].includes(promo?.promotion_type)
  ) {
    return promo?.text_to_show;
  } else {
    return display_benefit_tag;
  }
};
